import ProlongShareableLinkModal from './ProlongShareableLinkModal.component';

export default ProlongShareableLinkModal;
